<template>
<!-- 领导信箱-表单详情 -->
  <section class="interact-smart-index-detail">
    <!-- <base-header v-bind="headers"/> -->
    <el-main class="interact-smart-index-wrap">
        <component :is="'editQues'" :saveName="saveName" :name="'editQues'"></component>
    </el-main>
  </section>
</template>
<script>
import baseHeader from '@/components/mixins/baseHeader'
import editQues from './../../Smart/tabsComponents/editQues'
import { mapActions } from 'vuex'
export default {
  name: 'interactLetterFormDetail',
  mixins: [baseHeader],
  components: {
    editQues,
  },
  data () {
    return {
      headers: {
        title: '操作说明',
        showAlertIcon: true,
        content: '操作说明:   这里是关于该页面的相关操作说明文字。'
      },
      newquestTitle: '',
      id: null,
      lastName: '',
      saveName: ''
    }
  },
  methods: {
    ...mapActions('interact', ['getSmartDetailData', 'getCloseData']),
    // 详情
    getFormData () {
      let { link, state } = this.$route.query
      if (link) {
        this.activeTab = link
        this.lastName = link
        if (Number(state) !== 0) {
          this.tabPub.find((t) => t.name === 'linkAddress').isHidden = false
        } else {
          this.tabPub.find((t) => t.name === 'linkAddress').isHidden = true
        }
      } else {
        this.activeTab = 'editQues'
        this.lastName = ''
      }
      this.state = Number(state)
    },
    setTab (routeQuery) {
      const { link } = routeQuery
      if (link) {
        this.currentTab = this.tabPub
      } else {
        this.currentTab = this.tabs
      }
      this.getFormData()
    }
  },
  watch: {
    listenParamsObj: {
      handler: function (newVal, oldVal) {
        window.onbeforeunload = (newVal.path === '/interact/smart/detail' && (newVal.activeTab === 'editQues' || newVal.activeTab === 'setQues')) ? e => {
          // 通知浏览器不要执行与事件关联的默认动作
          e.preventDefault()
          // Chrome 需要 returnValue 被设置成空字符串
          e.returnValue = ''
        } : null
      }
    },
    '$route': function (newVal, oldVal) {
      if (newVal.path === '/interact/smart/detail') {
        this.setTab(newVal.query)
      }
    }
  },
  activated () {
    // this.setTab(this.$route.query)
  },
  destroyed () {
    window.onbeforeunload = null
  },
  computed: {
    listenParamsObj () {
      const { path } = this.$route
      const activeTab = this.activeTab
      return { path, activeTab }
    }
  },
  mounted () {
    this.getCloseData(true)
    window.onbeforeunload = e => {
      // 通知浏览器不要执行与事件关联的默认动作
      e.preventDefault()
      // Chrome 需要 returnValue 被设置成空字符串
      e.returnValue = ''
    }
  }
  // beforeRouteLeave: (to, from, next) => {
  //   if (confirm('确定离开此页面吗？ 系统可能不会保存您所做的更改')) {
  //     next()
  //   } else {
  //     next(false)
  //   }
  // }
}
</script>
<style lang="scss">
.interact-smart-index-detail{
  height: 100%;
  .interact-smart-index-wrap{
    height: 100%;
  }
  .el-tabs{
    height: 100%;
    &__content{
       height: calc(100% - 48px);
       overflow-y: auto;
    }
    .el-tab-pane{
       height: 100%;
    }
  }
}
</style>
